import { render } from "./RocksView.vue?vue&type=template&id=4f5465c8&scoped=true&ts=true"
import script from "./RocksView.vue?vue&type=script&lang=ts"
export * from "./RocksView.vue?vue&type=script&lang=ts"

import "./RocksView.vue?vue&type=style&index=0&id=4f5465c8&scoped=true&lang=css"

import exportComponent from "../../../../sf-playbook-app/APP/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f5465c8"]])

export default __exports__